import { type ColumnDef } from '@tanstack/react-table';
import { ColumnComponents } from '@/components/data-table/column-components/column-components';
import { type ColumnConfig } from '@/types/column';

/**
 * Turn declarative column configs into TanStack column defs: drop hidden ones,
 * then map each through its factory in {@link ColumnComponents}. Every list
 * page/layout used to inline this identical `filter().map()`. (DM-2393)
 */
export const buildColumns = <T>(configs: Array<ColumnConfig<T>>): Array<ColumnDef<T>> =>
  configs.filter(({ hide }) => !hide).map((config) => ColumnComponents[config.type](config.opts));
